// extracted by mini-css-extract-plugin
export default {"questionSection":"styles_questionSection__PbBCv","title":"styles_title__6UZMC","description":"styles_description__lFwyk"};